export const DEFAULT_VENUE_DISTANCE_METERS = 50;

export const DEFAULT_COINS_PER_HOUR = 1;

export const BONUS_PUB_ACUMULATOR = 3;

/**
 * Matches the "eur3" (europe-west1/europe-west4) multi-region location of the
 * default Firestore database. Cloud Functions default to this region (see
 * functions/src/index.ts), and the frontend calls them here too so
 * httpsCallable requests land in the same region as the functions.
 */
export const EU_REGION = "europe-west1";

/**
 * Gambling games that pay the full prize, half or a third, each with
 * probability `odds` (see calculateWinnings in functions/src/actions/shop.ts).
 * Each game's reveal animation must show which of those four outcomes
 * (full/half/third/nothing) the server picked.
 */
export const TIERED_GAME_TYPES = [
  "slots",
  "tombola",
  "darts",
  "pint",
  "chest",
  "crystal",
  "cups",
] as const;

export function isTieredGame(type: unknown): boolean {
  return (TIERED_GAME_TYPES as readonly unknown[]).includes(type);
}

/** `options.type` of the shop item whose hats are images uploaded by the buyer. */
export const CUSTOM_HAT_TYPE = "customHat";

/** Storage folder custom hat images are uploaded to: `customHats/{uid}/{fileName}`. */
export const CUSTOM_HAT_STORAGE_FOLDER = "customHats";

/** Mirrors the size cap on customHats in storage.rules. */
export const MAX_CUSTOM_HAT_BYTES = 2 * 1024 * 1024;

/** Longest edge, in pixels, a custom hat image is scaled down to before upload. */
export const MAX_CUSTOM_HAT_DIMENSION = 512;
